import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'

import {InputSelect} from '@vio/atlas/InputSelect'

import {sortLabels, sortList} from './ReviewSorting'

interface Props {
  onSortChange: (value: string) => void
}
const StyledInputSelect = styled(InputSelect)`
  width: 140px !important;
`

export const ReviewSortingDesktop: React.FC<Props> = ({onSortChange}) => {
  const {formatMessage} = useIntl()
  const [value, setValue] = useState(sortList[0].value)

  const handleOnChange = (value: string) => {
    setValue(value)
    onSortChange(value)
  }

  return (
    <StyledInputSelect
      size="sm"
      onChange={handleOnChange}
      ariaLabel={formatMessage(sortLabels.mostRelevant)}
      value={value}
    >
      {sortList.map(item => (
        <option key={item.key} value={item.value}>
          {formatMessage(sortLabels[item.key])}
        </option>
      ))}
    </StyledInputSelect>
  )
}
